export default class zuma {
  constructor() {
    this._name = 'zuma';
  }
  get name() {
    return this._name;
  }
}



/** WEBPACK FOOTER **
 ** F:/zan/www/panli/webpack-library-starter/~/.npminstall/eslint-loader/1.1.0/eslint-loader!./src/index.js
 **/